/**
 * DEV-261 US-10 — tela final (Figma 20186:22984). "Enviar outra descrição"
 * abre uma sessão nova em branco (FR-020): volta ao Onboarding do mesmo link.
 */
import { useNavigate } from '@tanstack/react-router';
import { SuccessScreen } from '@eureca/ui';
import { AppBar } from '../shared/FormHeader';
import { SUCCESS } from '../shared/messages';
import { clearAlignmentSession } from '../shared/session';

export function SuccessPage({ tenant, formId }: { tenant: string; formId: string }) {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <AppBar />
      <div className="flex flex-1 items-center justify-center pb-16">
        <SuccessScreen
          title={SUCCESS.title}
          paragraphs={[...SUCCESS.paragraphs]}
          actionLabel={SUCCESS.another}
          onAction={() => {
            clearAlignmentSession(formId);
            void navigate({
              to: '/descricao-vaga/$tenant/$formId',
              params: { tenant, formId },
              replace: true,
            });
          }}
          data-testid="success-page"
        />
      </div>
    </div>
  );
}
